import { useEffect } from "react";

export default function ThemeProvider({ children, themeData }) {
  useEffect(() => {
    if (!themeData) return;
    themeData?.primaryColor &&
      document.documentElement.style.setProperty("--color-primary", themeData?.primaryColor);
    themeData?.secondaryColor &&
      document.documentElement.style.setProperty("--color-secondary", themeData?.secondaryColor);
    themeData?.textOnPrimaryColor &&
      document.documentElement.style.setProperty(
        "--color-text-on-primary",
        themeData?.textOnPrimaryColor,
      );
  }, [themeData]);

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
}
